import { render, staticRenderFns } from "./StatusDashboardTable.vue?vue&type=template&id=ab118716&scoped=true&"
import script from "./StatusDashboardTable.vue?vue&type=script&lang=js&"
export * from "./StatusDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./StatusDashboardTable.vue?vue&type=style&index=0&id=ab118716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab118716",
  null
  
)

export default component.exports